module.exports = __webpack_public_path__ + "9ad84d7a3643497654c7a02aedbebe8a.pdf";